export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-default.d7XjgQo25CeZCbeOnR-HxyXAreoApsIcbge5_Hdkb3A.svg",
  "sidebar": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-sidebar.ZAd2uncFSKTfpePADNL1S-znq56LGe3Dm-5S1XpSong.svg",
  "leaderboard": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-leaderboard.qcETGgunkY80jFZ4ysDjDOjHhA6srSulaMfI4ujTqhM.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "account-events-empty",
  "affiliates-campaigns",
  "affiliates-commissions",
  "affiliates-lead",
  "affiliates-media",
  "affiliates-payouts",
  "affiliates-sub-affiliate",
  "affiliates-tax-form",
  "discover-empty",
  "invoices-empty",
  "leaderboard/leaderboard-first-place",
  "leaderboard/leaderboard-second-place",
  "leaderboard/leaderboard-third-place",
  "resource-empty",
  "sidebar/affiliates",
  "sidebar/affiliates-active",
  "sidebar/appointments",
  "sidebar/appointments-active",
  "sidebar/communities",
  "sidebar/communities-active",
  "sidebar/contracts",
  "sidebar/contracts-active",
  "sidebar/courses",
  "sidebar/courses-active",
  "sidebar/dashboard",
  "sidebar/dashboard-active",
  "sidebar/documents",
  "sidebar/documents-active",
  "sidebar/estimates",
  "sidebar/estimates-active",
  "sidebar/events",
  "sidebar/events-active",
  "sidebar/explore",
  "sidebar/explore-active",
  "sidebar/invoices",
  "sidebar/invoices-active",
  "sidebar/loyalty",
  "sidebar/loyalty-active",
  "sidebar/studio",
  "sidebar/studio-active"
]);